module.exports = __webpack_public_path__ + "img/filter-type-arms--active.9a422f6f.svg";